import axios from 'axios';
import { Dispatch } from 'redux';
import { clearQueryStringOnCurrentUrl } from '../../../helpers/queryParams';
import { setOryLoginStatus, setOryLoginType } from '../../../modules/auth/actions';
import { getCurrentUser } from '../../../modules/user/actions';
import { OryApiRequestCancelTokenId } from '../../config/const';
import { OryCancelled, OryLoginStatus, OryLoginType } from '../../types';
import { IUseLoginApi } from '../oryApi';
import { IUseOryResponseParser } from '../oryResponseParser';
import { IUseOryUserLoggedProps } from './data';

export function checkOrySessionIfNeeded({
  accessToken,
  currentUser,
  dispatch,
  getOryCurrentUserSession,
  isSSOLogin,
  oryLoginStatus,
  parseOryResponseWithData,
  setIsOrySessionCheckResolved,
}: {
  getOryCurrentUserSession: IUseLoginApi['getOryCurrentUserSession'];
  dispatch: Dispatch;
  setIsOrySessionCheckResolved: React.Dispatch<React.SetStateAction<boolean>>;
  accessToken: IUseOryUserLoggedProps['accessToken'];
  currentUser: IUseOryUserLoggedProps['currentUser'];
  oryLoginStatus: OryLoginStatus | undefined;
  isSSOLogin?: boolean;
  parseOryResponseWithData: IUseOryResponseParser['parseOryResponseWithData'];
}) {
  const cancelTokenSource = axios.CancelToken.source();
  const tryToGetOrySession = async (isSSOLogin?: boolean) => {
    const response = await getOryCurrentUserSession({ cancelToken: cancelTokenSource.token });

    parseOryResponseWithData({
      onSuccess: (data) => {
        dispatch(setOryLoginStatus(OryLoginStatus.SessionConfirmed));
        if (data.isUserLoggedAsOrySso) {
          if (!currentUser?.id) {
            dispatch(getCurrentUser());
          }
          dispatch(setOryLoginType(OryLoginType.Sso));
        }
      },
      response,
    });

    if (response !== OryCancelled) {
      setIsOrySessionCheckResolved(true);
    }
    if (isSSOLogin) {
      clearQueryStringOnCurrentUrl();
    }
  };

  if (
    (isOryUserPotentiallyAlreadyLoggedIn(accessToken, currentUser) || isSSOLogin) &&
    oryLoginStatus !== OryLoginStatus.SessionConfirmed
  ) {
    tryToGetOrySession(isSSOLogin);
  } else {
    setIsOrySessionCheckResolved(true);
  }

  return () => {
    cancelTokenSource.cancel(OryApiRequestCancelTokenId);
  };
}

export function isOryUserPotentiallyAlreadyLoggedIn(
  accessToken: IUseOryUserLoggedProps['accessToken'],
  currentUser: IUseOryUserLoggedProps['currentUser']
): boolean {
  return !!(!accessToken && currentUser && currentUser.id);
}
